/** @format */

import { SvgIcon } from '@mui/material';
import { get } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'src/hooks/use-auth';
// import HomeSmileIcon from 'src/icons/untitled-ui/duocolor/home-smile';
import HomeSmileIcon from '@untitled-ui/icons-react/build/esm/HomeSmile';
import BookingIcon from '@untitled-ui/icons-react/build/esm/MarkerPin04';
import SettingIcon from '@untitled-ui/icons-react/build/esm/Settings03';
import { userKeyValueRoles } from 'src/config';
import { usePermission } from 'src/hooks/use-permisstion';
import Users03Icon from 'src/icons/untitled-ui/duocolor/users-03';
import { tokens } from 'src/locales/tokens';
import { paths } from 'src/paths';

const useManagementItems = () => {
  const { t } = useTranslation();
  const managementItems = [
    {
      title: t(tokens.nav.managementOverview),
      path: paths.management.overview
    },
    {
      title: t(tokens.nav.managementAnalytic),
      path: paths.management.analytic
    },

    {
      title: t(tokens.nav.managementSchedule),
      path: paths.management.schedule
    },
    {
      title: t(tokens.nav.managementCar),
      path: paths.management.car.index
    }
  ];

  // if (includes(access_controls, 'permissions_control__manage_dashboard__view')) {
  //   managementItems.push({
  //     title: t(tokens.nav.managementDashboard),
  //     path: paths.management.dashboard
  //   });
  // }

  return managementItems;
};

export const useSections = () => {
  const { t } = useTranslation();
  const {
    user: { permissions, role }
  } = useAuth();

  const managementItems = useManagementItems(permissions);

  const { accessConfigurationMenu, accessUserMenu, accessBookingMenu } = usePermission({
    accessConfigurationMenu: 'configurationMenu',
    accessUserMenu: 'userMenu',
    accessBookingMenu: 'bookingMenu'
  });

  return useMemo(() => {
    return [
      {
        items: [
          ...(role === get(userKeyValueRoles, 'isNhaXe')
            ? managementItems
            : [
                {
                  title: t(tokens.nav.management),
                  path: '#',
                  icon: (
                    <SvgIcon fontSize="small">
                      <HomeSmileIcon />
                    </SvgIcon>
                  ),
                  items: managementItems
                }
              ]),
          ...(accessBookingMenu
            ? [
                {
                  title: t(tokens.nav.booking),
                  path: paths.booking.list,
                  icon: (
                    <SvgIcon fontSize="small">
                      <BookingIcon />
                    </SvgIcon>
                  )
                }
              ]
            : []),

          ...(accessConfigurationMenu
            ? [
                {
                  title: t(tokens.nav.configuration),
                  path: paths.configuration.carBrand,
                  icon: (
                    <SvgIcon fontSize="small">
                      <SettingIcon />
                    </SvgIcon>
                  )
                }
              ]
            : []),
          ...(accessUserMenu
            ? [
                {
                  title: t(tokens.nav.managementUser),
                  path: paths.management.user.index,
                  icon: (
                    <SvgIcon fontSize="small">
                      <Users03Icon />
                    </SvgIcon>
                  )
                }
              ]
            : [])
        ]
      }
    ];
  }, [managementItems]);
};
